import { render, staticRenderFns } from "./BaseFooter.vue?vue&type=template&id=d961d9a6&"
import script from "./BaseFooter.vue?vue&type=script&lang=js&"
export * from "./BaseFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports